import React from "react";
import { useLocation, Switch, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import UserNavbar from "components/Navbars/UserNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import UserRoute from "routes/UserRoute";
import userRoutes from "routes/userRoutes.js";
import ChangePassword from "views/examples/ChangePassword";
import UserSidebar from "components/Sidebar/UserSidebar";
const User = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/user") {
        return (
          <UserRoute
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < userRoutes.length; i++) {
      if (
        props.location.pathname.indexOf(userRoutes[i].layout + userRoutes[i].path) !==
        -1
      ) {
        return userRoutes[i].name;
      }
    }
    return "Zmiana hasła";
  };

  return (
    <>
      <UserSidebar
        {...props}
        routes={userRoutes}
        logo={{
          innerLink: "/user/examinations",
          imgSrc: require("../assets/img/brand/argon-react.png").default,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <UserNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes(userRoutes)}
          <UserRoute
            path={"/user/change-password"}
            component={ChangePassword}
            key={"/user/change-password"}
          />
          <Redirect from="*" to="/user/examinations" />
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default User;